import { useMutation, useQueryClient } from 'react-query';
import { useToast } from '@razorpay/blade/components';
import api from 'api';
import { UpdateEmployeeDataGeneralSettingsInput } from 'api/gql-utils/employeeDataSettings/types';
import { EMPLOYEE_DATA_GENERAL_QUERY_KEY } from './useEmployeeDataGeneralSettings';

export const useUpdateEmployeeDataGeneralSettings = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation(
    (input: UpdateEmployeeDataGeneralSettingsInput) =>
      api.employeeDataSettings.mutations.updateEmployeeDataGeneralSettings({ input }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(EMPLOYEE_DATA_GENERAL_QUERY_KEY);
        toast.show({ content: 'Employee data settings saved', color: 'positive' });
      },
      onError: () => {
        toast.show({ content: 'Could not save employee data settings', color: 'negative' });
      },
    },
  );
};
